import styles from './Cart.module.scss';
const Cart = () => {
  return (
    <>
      <div className={styles.container_cart}>
        Hello World
        <div></div>
      </div>
    </>
  );
};

export default Cart;
